import { MapPin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const mapImg =
  "https://static.prod-images.emergentagent.com/jobs/7d38956f-74c5-4266-a29e-5f2f50e06042/images/1ae856e6702fa9055c0a95e67fdcef62a86f45000c01988b03f08b533403c6a3.png";

export default function GlobalPresence() {
  const { t } = useLang();
  return (
    <section id="global" className="py-24 lg:py-32 relative overflow-hidden" data-testid="global-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="bbm-eyebrow mb-4">— {t.global.eyebrow}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B132B] leading-tight tracking-tight mb-6">
              {t.global.title}
            </h2>
            <p className="text-[#4B5563] text-lg leading-relaxed mb-10">
              {t.global.sub}
            </p>

            <div className="space-y-5">
              <div className="border border-[#E5E7EB] rounded-lg p-6" data-testid="hq-card">
                <div className="flex items-center gap-2 mb-1">
                  <MapPin className="w-4 h-4 text-[#0047FF]" />
                  <span className="font-mono text-[11px] uppercase tracking-widest text-[#0047FF]">
                    {t.global.hq}
                  </span>
                </div>
                <h3 className="font-display text-2xl text-[#0B132B] mb-2">
                  {t.global.hq_loc}
                </h3>
                <p className="text-sm text-[#4B5563] leading-relaxed">{t.global.hq_desc}</p>
              </div>

              <div className="border border-[#E5E7EB] rounded-lg p-6 bg-[#0B132B] text-white" data-testid="branch-card">
                <div className="flex items-center gap-2 mb-1">
                  <MapPin className="w-4 h-4 text-[#FFB800]" />
                  <span className="font-mono text-[11px] uppercase tracking-widest text-[#FFB800]">
                    {t.global.branch}
                  </span>
                </div>
                <h3 className="font-display text-2xl mb-2">{t.global.branch_loc}</h3>
                <p className="text-sm text-white/75 leading-relaxed">{t.global.branch_desc}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-[#E5E7EB] bg-[#F9FAFB]">
              <img
                src={mapImg}
                alt="Global presence: US to Algeria"
                className="w-full h-full object-cover"
                data-testid="global-map-image"
              />
              <div className="absolute bottom-4 start-4 bg-white/95 backdrop-blur px-4 py-2 rounded-md border border-white/40 shadow-lg">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#4B5563]">Bridging</div>
                <div className="font-display text-base text-[#0B132B]">US ↔ Algeria</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
